module.exports = __webpack_public_path__ + "media/images/okra-logo-d4aa80b7db4be491f0c48a9a20db15b7.svg";